import { FunctionComponent, PropsWithChildren } from "react";
import { NotificationBarContainer, NotificationBarContent, NotificationBarIcon } from "./styles";
import { IconClose } from "@manifesthhqinc/ui-library";

interface NotificationBarProps extends PropsWithChildren {
  show: boolean;
  closeNote: () => void;
}

const NotificationBar: FunctionComponent<NotificationBarProps> = ({
  children,
  show,
  closeNote,
}: NotificationBarProps) => {
  if (!show) return <></>;
  return (
    <NotificationBarContainer>
      <NotificationBarIcon>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 2C12.8646 2.00001 13.6934 2.16787 14.4541 2.47363C13.97 2.96043 13.5868 3.54725 13.335 4.19922C12.9114 4.07038 12.4633 4.00001 12 4C9.66305 4 7.69949 5.75742 7.44141 8.08008L7.18945 10.3457C7.18632 10.3739 7.18451 10.3907 7.18262 10.4072C7.03755 11.6714 6.62631 12.8909 5.97559 13.9844C5.96719 13.9985 5.95877 14.013 5.94434 14.0371L5.36621 15C5.09273 15.4558 4.92761 15.7334 4.83008 15.9404C4.82528 15.9506 4.82149 15.9606 4.81738 15.9697C4.82778 15.971 4.83875 15.9744 4.85059 15.9756C5.07832 15.9985 5.40114 16 5.93262 16H18.0674C18.5989 16 18.9217 15.9985 19.1494 15.9756C19.1609 15.9744 19.1715 15.9709 19.1816 15.9697C19.1776 15.9607 19.1747 15.9505 19.1699 15.9404C19.0724 15.7334 18.9073 15.4558 18.6338 15L18.0557 14.0371C18.0412 14.013 18.0328 13.9985 18.0244 13.9844C17.454 13.0258 17.0672 11.9705 16.8828 10.873C17.2421 10.9551 17.6159 11 18 11C18.3168 11 18.6263 10.9684 18.9268 10.9121C19.0883 11.6324 19.3641 12.3239 19.7432 12.9609C19.7494 12.9714 19.7553 12.9824 19.7705 13.0078L20.3486 13.9707C20.5997 14.3891 20.8289 14.7681 20.9795 15.0879C21.1276 15.4023 21.2852 15.8285 21.209 16.3115C21.1337 16.7889 20.8881 17.2229 20.5176 17.5332C20.1425 17.8471 19.6955 17.931 19.3496 17.9658C18.998 18.0012 18.5553 18 18.0674 18H5.93262C5.44475 18 5.00204 18.0012 4.65039 17.9658C4.30452 17.931 3.85748 17.8471 3.48242 17.5332C3.11184 17.2229 2.86635 16.789 2.79102 16.3115C2.71484 15.8285 2.87242 15.4024 3.02051 15.0879C3.1711 14.7681 3.40033 14.3891 3.65137 13.9707L4.22949 13.0078C4.24473 12.9824 4.25062 12.9714 4.25684 12.9609C4.76288 12.1106 5.08342 11.1628 5.19629 10.1797C5.19768 10.1676 5.19886 10.1546 5.20215 10.125L5.4541 7.85938C5.82472 4.52385 8.64395 2 12 2ZM16.9824 4.28027C17.8279 5.25764 18.3937 6.48978 18.5459 7.85938L18.5527 7.91992C18.377 7.97044 18.192 7.99999 18 8C17.3124 8 16.7066 7.65243 16.3467 7.12402C16.2651 6.88124 16.1646 6.64784 16.0459 6.42578C16.0161 6.28854 16 6.14616 16 6C16 5.2674 16.3949 4.62865 16.9824 4.28027Z"
            fill="#3A9289"
          />
          <path
            d="M9.10222 17.6647C9.27315 18.6215 9.64978 19.467 10.1737 20.0701C10.6976 20.6731 11.3396 21 12 21C12.6604 21 13.3024 20.6731 13.8263 20.0701C14.3502 19.467 14.7269 18.6215 14.8978 17.6647"
            stroke="#3A9289"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle cx="18" cy="6" r="2.5" fill="#3A9289" stroke="#3A9289" />
        </svg>
      </NotificationBarIcon>
      <NotificationBarContent>{children}</NotificationBarContent>
      <NotificationBarIcon $isButton>
        <IconClose onClick={closeNote} size="small" />
      </NotificationBarIcon>
    </NotificationBarContainer>
  );
};

export default NotificationBar;
